import {createSlice, Dispatch, PayloadAction} from '@reduxjs/toolkit';

interface List {
  key: string;
  list: Array<any>
}

const initialState: any = {
}

const listsSlice = createSlice({
  name: 'lists',
  initialState,
  reducers: {
    setInternalList(state, action: PayloadAction<List>): void {
      const {payload} = action;
      state[payload.key] = payload.list;
    },
  }
});

const {
  setInternalList,
} = listsSlice.actions;

// Define a thunk that dispatches those action creators
export const setList = (key: string, list: Array<any>) => (dispatch: Dispatch) => {
  dispatch(setInternalList({key, list}));
}

export default listsSlice.reducer;
